<template>
  <div class="new-orders">
    <div class="h2" @click="toggleShowAll">
      Новые заказы ({{ newOrders.length }}) 
      <!--<span v-if="newOrders.length > 10">
        ({{ showAll ? "Скрыть" : "Показать все" }})
      </span>-->
    </div>
    <div v-if="newOrders.length" class="orders-list">
      <div
        v-for="(order, index) in visibleOrders"
        :key="order.id"
        class="order-item"
        @click="openOrder(order.id, order.number, order.site, order.createdAt, order.phone, order.orderMethod)"
      >

        <div class="prod">
          <span class="img-st"></span> 
          <span class="bill__title">Новый <span style="display:none;">{{index}}</span></span>
        </div>
        <p>{{ new Date(order.createdAt).toLocaleString() }}</p>
      </div>
    </div>
    <p v-else class="no-orders">Новых заказов нет</p>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapMutations } from "vuex";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast);
export default {
  name: "NewOrders",
  inject: ["ws"], // Подключаем WebSocket из App.vue
  data() {
    return {
      showAll: false, // Управление видимостью заказов
    };
  },
  computed: {
    ...mapState("newOrdersModule", {
      newOrders: (state) => state.newOrders,
    }),
    visibleOrders() {
      return this.showAll ? this.newOrders : this.newOrders.slice(0, 10);
    },
  },
  methods: {
    ...mapActions("newOrdersModule", ["fetchNewOrders", "removeOrder"]),
    ...mapMutations("newOrdersModule", ["REMOVE_ORDER"]),

    ...mapActions({
      // Подключение экшенов из модуля savedFormsModule
      loadSavedForms: "savedFormsModule/loadSavedForms",
      saveForm: "savedFormsModule/saveForm",
      deleteForm: "savedFormsModule/deleteForm",
    }),
    
    toggleShowAll() {
      this.showAll = !this.showAll; // Переключаем видимость
    },

    // Метод для перехода на страницу заказа
    openOrder(orderNumber, number, orderSite, orderCreated, orderPhone, orderMethod) {
      const ws = this.ws(); // Получаем WebSocket через inject
      console.log("WebSocket соединение:", ws);

      // Проверяем наличие сохраненных форм
      const hasSavedForms = this.$store.getters['savedFormsModule/hasSavedForms'];
      if (hasSavedForms) {
        console.warn("Есть несохраненные формы. Переход запрещен.");
        this.$toast.warning("Сначала обработайте заказ, прежде чем продолжить.");
        return; // Останавливаем выполнение функции
      }

      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({ type: "orderRemoved", data: { id: orderNumber } }));
        console.warn("WebSocket установлен.");
      } else {
        console.warn("WebSocket не установлен или закрыт.");
      }
      this.removeOrder(orderNumber); // Удаляем заказ из Vuex
      
      this.$store.dispatch('savedFormsModule/clearSavedForms');
      this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
      const formData = { id:orderNumber, idorder:orderNumber, number:number, site: orderSite, created:orderCreated, phone:orderPhone, orderMethod:{label:orderMethod} };
      this.saveForm(formData);
      // Переходим на страницу редактирования заказа
      this.$router.push({ name: "OrderEdit", params: { orderId: orderNumber, site: orderSite } });
    },
  },
  beforeDestroy() {
    clearInterval(this.interval); // Удаляем интервал
  },
};
</script>


<style scoped>
.h2 {
  background: linear-gradient(180deg, #fea530, #e48e1e) !important;
  color: #fff;
  padding: 7px 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  text-align: center;
  margin-bottom: 7px;
  font-size: 14px;
  cursor:pointer;
}

.new-orders {
  margin-top: 20px;
  padding: 0px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 2px 2px 4px rgb(0 0 0 / 5%);
  overflow: hidden;
}

.orders-list {
    padding: 0px 2px;
    display: flex;
    flex-wrap: wrap;
        justify-content: space-between;
}



.order-item {
 padding: 0px;
    margin-bottom: 2px;
    border: 0px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    width: 49.5%;
}


.order-item:hover {
  background: linear-gradient(180deg, #e48e1e, #fea530) !important;
}

.no-orders {
  text-align: center;
  margin-top: 15px;
}

.img-st {
background-image:
  url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-position: 50%;
    background-repeat: no-repeat;
    height: 20px;
    left: 0px;
    margin-top: 0px;
    position: absolute;
    top: 0%;
    width: 20px;
    background-size: 70%;
}

.order-item .prod{
    background: transparent;
    color: #ffffff;
    padding: 0 12px 0 24px;
    font-size: 12px;
    min-height: 20px;
    display: flex;
    align-items: center;
    border-radius: 0px;
    position: relative;
}

.order-item p{
  font-size: 10px;
    color: #fff;
    padding: 4px;
    border-top: solid 0px #0000001c;
    line-height: 11px;
    margin-bottom: 0px;
}


.Vue-Toastification__toast--warning {
   
    max-width: 235px;
    min-width: 200px;
}
</style>
